export const showInfoAct = (state, action) => {
    const thekr = state.data.find(thekr => thekr.id === action.payload);
    if (thekr) {
      thekr.showInfo = !thekr.showInfo;
    }
  };
  
  export const numDecreaseAct = (state, action) => {
   
    const thekr =  state.data.find(thekr => thekr.id === action.payload);
  
    if (thekr) {
      thekr.repeat = Math.max(0, thekr.repeat - 1);
   
    }
   
  };
  export const prograssNum = (state, action) => {
  
    state.value = state.value + action.payload


  }


